var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-path"},[_c('el-breadcrumb',_vm._l((_vm.pathList),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(" "+_vm._s(item.meta.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }